export default function Testimonials() {
  const testimonials = [
    {
      rating: 5,
      quote: 'The best decision we ever made!',
      text: 'PawCare has been amazing for our golden retriever Max. The staff is so loving and professional. He gets excited every time we pull up!',
      name: 'Sarah Johnson',
      pet: 'Max the Golden Retriever',
      avatar: 'https://public.readdy.ai/ai/img_res/408d517de1da2b4743fd734304e11836.jpg',
    },
    {
      rating: 5,
      quote: 'Our cat finally loves grooming day!',
      text: 'Luna used to hate grooming, but the gentle approach at PawCare changed everything. They truly understand cats and their unique needs.',
      name: 'Michael Chen',
      pet: 'Luna the Persian Cat',
      avatar: 'https://readdy.ai/api/search-image?query=asian-man-smiling-professional-portrait-friendly-face-casual-business-attire-natural-lighting-warm-background&width=120&height=120&seq=avatar-002&orientation=squarish',
    },
    {
      rating: 5,
      quote: 'Peace of mind when we travel',
      text: 'Knowing that Bella is in such caring hands makes our trips stress-free. The daily photo updates are the sweetest touch!',
      name: 'Emily Rodriguez',
      pet: 'Bella the Beagle',
      avatar: 'https://readdy.ai/api/search-image?query=hispanic-woman-smiling-professional-headshot-warm-friendly-expression-brunette-hair-natural-lighting-soft-background&width=120&height=120&seq=avatar-003&orientation=squarish',
    },
    {
      rating: 5,
      quote: 'Exceptional veterinary care',
      text: 'Dr. Anderson diagnosed Charlie\'s condition quickly and the treatment plan was perfect. We\'re so grateful for their expertise.',
      name: 'David Thompson',
      pet: 'Charlie the Labrador',
      avatar: 'https://readdy.ai/api/search-image?query=middle-aged-man-smiling-professional-portrait-gray-hair-friendly-expression-business-casual-natural-lighting&width=120&height=120&seq=avatar-004&orientation=squarish',
    },
    {
      rating: 5,
      quote: 'Training classes that actually work!',
      text: 'Rocky went from unruly puppy to well-behaved companion thanks to the patient trainers. Highly recommend their programs!',
      name: 'Jessica Martinez',
      pet: 'Rocky the German Shepherd',
      avatar: 'https://readdy.ai/api/search-image?query=young-woman-smiling-professional-headshot-dark-hair-friendly-warm-expression-natural-lighting-soft-background&width=120&height=120&seq=avatar-005&orientation=squarish',
    },
    {
      rating: 5,
      quote: 'A home away from home',
      text: 'Milo stays here when we work late and he absolutely loves it. The play areas are fantastic and the staff is wonderful.',
      name: 'Robert Kim',
      pet: 'Milo the Corgi',
      avatar: 'https://readdy.ai/api/search-image?query=asian-man-glasses-smiling-professional-portrait-friendly-expression-casual-attire-natural-lighting-warm-background&width=120&height=120&seq=avatar-006&orientation=squarish',
    },
  ];

  return (
    <section id="testimonials" className="py-24 px-6 bg-[#F8F5FF] relative overflow-hidden">
      {/* Wave dividers */}
      <div className="absolute top-0 left-0 right-0 h-16 bg-gradient-to-b from-[#E6E0F5] to-transparent"></div>
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-[#E6E0F5] to-transparent"></div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16 animate-fade-in-up">
          <h2 className="text-5xl font-bold text-[#4A3B5C] mb-2 font-heading">
            Pet Parents Say
          </h2>
          <div className="w-24 h-1 bg-[#FF9B9B] mx-auto mt-4 rounded-full"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className={`bg-white rounded-[28px] p-10 shadow-md hover:shadow-xl hover:-translate-y-2 transition-all duration-300 cursor-pointer flex flex-col animate-scale-in animate-delay-${Math.min((index + 1) * 100, 600)}`}
            >
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#FF9B9B] text-xl"></i>
                ))}
              </div>

              <p className="text-xl font-bold text-[#4A3B5C] mb-3 italic relative">
                {testimonial.quote}
                <span className="text-4xl text-[#FF9B9B] ml-1">"</span>
              </p>

              <p className="text-[#8B7BA8] leading-relaxed mb-6 flex-grow">{testimonial.text}</p>

              <div className="flex items-center gap-4 pt-4 border-t border-[#E6E0F5] mt-auto">
                <img
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  className="w-14 h-14 rounded-full border-3 border-[#D4C5F0] object-cover"
                />
                <div>
                  <p className="font-bold text-[#4A3B5C]">{testimonial.name}</p>
                  <p className="text-sm text-[#8B7BA8] flex items-center gap-1">
                    <i className="ri-footprint-fill text-xs"></i>
                    {testimonial.pet}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
